<template>
  <div v-if="!model.$disabled" class="mb-3">
    <label v-if="getTitle" :for="sid">
      {{ getTitle }}
      <w-tooltip v-if="tooltipContent && tooltipContent.length">{{ tooltipContent }}</w-tooltip>
    </label>

    <textarea
      :id="sid"
      ref="input"
      style="overflow: hidden"
      :aria-invalid="errorVisible"
      :aria-describedby="errorVisible ? errId : undefined"
      :disabled="disabled"
      :readonly="model.$schema.readOnly"
      :value="svalue"
      :class="classObject"
      :placeholder="placeholder"
      :name="model.$form.testPath ? model.$path : undefined"
      @input="onInput($event)"
      @blur="onTextareaBlur($event)"
      @focus="onTextareaFocus($event)"
    />

    <textarea v-if="useHelper" ref="hresize" class="form-control areahelper" style="overflow: hidden" tabindex="-1" />

    <div v-if="model.$schema.maxLength !== undefined" class="text-note text-muted">
      <small :class="{ 'text-danger': !model.$hasFocus && length > model.$schema.maxLength }">
        {{ length }} z {{ model.$schema.maxLength || 0 }}
      </small>
    </div>

    <w-error :model="model" :err-id="errId" @focus="$refs.input.focus()" />
  </div>
</template>

<script>
import modelMixin from '../mixins/modelMixin';
import { errorMixin } from '../mixins/errorMixin';
import WError from './error.vue';
import WTooltip from './tooltip.vue';

export default {
  name: 'WTextarea',
  components: { WError, WTooltip },
  mixins: [modelMixin, errorMixin('txt')],
  props: {
    placeholder: String,
    appendicon: {
      type: String,
      default: ''
    },
    prependicon: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      length: 0,
      useHelper: false
    };
  },

  computed: {
    classObject() {
      const result = ['form-control'];
      if (this.borderless) {
        result.push('borderless');
        if (this.useHelper) {
          result.push('active');
        }
      }
      if (this.model.$error) {
        result.push('is-invalid');
      }
      if (this.model.$error) {
        result.push('is-invalid');
      } else if (this.model.$warnings.length) {
        result.push('is-warning');
      }
      return result;
    }
  },
  mounted() {
    this.$watch('svalue', {
      handler(newValue) {
        this.resize(newValue);
      }
    });
  },
  methods: {
    // Ustawia wielkość text-area
    resize(newValue, blur) {
      if (newValue === undefined) {
        if (this.svalue === undefined) {
          newValue = '';
        } else {
          newValue = this.svalue;
        }
      }

      this.length = (newValue || '').length || 0;

      let newHeight = 0;
      if (this.useHelper) {
        if (this.$refs.hresize === undefined) {
          return;
        }
        if (blur) {
          return;
        }

        this.$refs.hresize.value = newValue + 'aaa';
        const height = this.$refs.hresize.scrollHeight;
        newHeight = height + 2;
      } else {
        if (this.$refs.input === undefined) {
          return;
        }
        newHeight = this.$refs.input.scrollHeight + 2;
      }

      this.$refs.input.style.overflow = 'hidden';
      this.$refs.input.style.height = newHeight + 'px';
    },
    // Ustawia helper przy focus
    onTextareaFocus(evt) {
      this.useHelper = true;
      this.onFocus(evt);
    },
    // Ustawia helper przy blur
    onTextareaBlur(evt) {
      this.useHelper = false;
      this.onBlur(evt);
    }
  }
};
</script>

<style>
textarea.areahelper {
  position: absolute;
  top: -9999px;
  left: -9999px;
}
textarea.active {
  background-color: lightyellow !important;
}
</style>
